import React, {useState} from "react"
import {NotificationManager} from "react-notifications";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Card, Modal, Popover} from "react-bootstrap";
import _ from "lodash"

const classObj = {
    0: 'one',
    1: 'two',
    2: 'three',
    3: 'four',
    4: 'five',
    5: 'six',
    6: 'seven',
    7: 'eight',
}


class CategoryBlock extends React.PureComponent {
    events = {
        showModal: (data) => {
            console.log(data);
            this.setState({
                visible: true,
                info: data.info,
                name: data.name,
            })
        },
        hideModal: () => {
            this.setState({
                visible: false,
                info: "",
                name: "",
            })
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            selectedCategory: "",
            visible: false,
            info: "",
            name: ""
        }
    }

    checkInclude = (id) => {
        let findAA = _.find(this.props.serviceList, (v) => {
            return v.name == id
        })
        return findAA ? true : false
    }

    render() {
        let {categoryList, productFxn, isMobileView} = this.props;
        let {visible, info, name} = this.state;
        return (
            <div>
                <div className={'category-list-grid'}>
                    {
                        categoryList.map((item, index) => {
                            let isExists = this.checkInclude(item.name);
                            return (
                                <div className={'category-ul'} key={index}>
                                    <a className={`${classObj[index]} cont-tb-inner`}
                                       onClick={() => productFxn(item.name, isExists)}>
                                        {isExists ?
                                            <i className={'fa fa-check-circle selected'}/> :
                                            <i className={'fa fa-circle'} style={{color: "gray"}}/>
                                        }

                                        {isMobileView ?
                                            <label>{item.shortName || item.name}</label> :
                                            <label>{item.name}</label>}
                                    </a>
                                    <a onClick={() => {
                                        this.events.showModal(item)
                                    }}>
                                        <i className={'fa fa-info-circle info-icon'}></i>
                                    </a>
                                </div>
                            )
                        })
                    }
                </div>


                <Modal show={visible} onHide={this.events.hideModal}
                       centered
                       size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="rt-list element-four fqlsst p-2">
                            {info}
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}


class PlaceOrderServiceComponent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            categoryList: [],
            selectIndex: 0,
            totalPrice: 0,
            show: false,
            selectedProduct: {},
            serviceList: []
        }
    }

    componentDidMount() {
        this.setState({serviceList: this.props.serviceList, selectIndex: this.props.selectedIndex})
    }

    componentDidUpdate(prevProps) {
        if (prevProps.serviceList !== this.props.serviceList || prevProps.selectedIndex !== this.props.selectedIndex) {
            this.setState({serviceList: this.props.serviceList, selectIndex: this.props.selectedIndex})
        }
    }

    handleClose = () => {
        this.setState({show: false, selectedProduct: {}})
    }

    choosePro(item) {

        this.chooseService({name: item});
    }

    removePro(categoryId) {
        let cloneService = _.clone(this.state.serviceList);
        cloneService = _.reject(cloneService, (item) => {
            return item.name == categoryId;
        })
        this.setState({serviceList: cloneService, show: false}, () => {
            let {serviceList} = this.state;
            this.props.returnServiceList(serviceList)
        })
    }


    chooseService(data) {
        let cloneService = _.clone(this.state.serviceList);
        let findCate = _.find(cloneService, (item) => {
            return item.name == data;
        })
        if (!findCate) {
            cloneService.push(data)
        }
        this.setState({serviceList: cloneService, show: false}, () => {
            let {serviceList} = this.state;
            this.props.returnServiceList(serviceList, this.state.selectIndex);
        })
    }


    productFxnLocal = (item, isExists) => {
        isExists ? this.removePro(item) : this.choosePro(item)
    }

    render() {
        let {selectIndex, show, selectedProduct, serviceList} = this.state;
        let {categoryList, isMobileView} = this.props;
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <CategoryBlock categoryList={categoryList} serviceList={serviceList}
                                       isMobileView={isMobileView}
                                       selectIndex={selectIndex} productFxn={this.productFxnLocal}/>
                    </div>
                </div>
                <Modal show={show} onHide={this.handleClose}
                       size="lg"
                       centered>
                    <Modal.Header closeButton>
                        <Modal.Title>{selectedProduct.name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={'row'}>
                            {selectedProduct.subCategory && selectedProduct.subCategory.length && selectedProduct.subCategory.map((item, key) => {
                                return (
                                    <div className={'col-md-6'}>
                                        <Card className={'bootstrap_card'}>
                                            <div className="product-add" key={key}
                                                 onClick={() => this.chooseService({
                                                     ...item,
                                                     name: selectedProduct.name
                                                 })}>
                                                {item && item.image && item.image.url ?
                                                    <LazyLoadImage style={{height: 74}}
                                                                   src={item.image.url}/> : null}

                                                <div className={'bootstrap_card_title'}>{item.name}</div>

                                            </div>
                                        </Card>
                                    </div>
                                )
                            })}
                        </div>

                    </Modal.Body>
                </Modal>

            </React.Fragment>
        )
    }
}


const Step2 = (props) => {
    let {categoryList, serviceList, selectedIndex, returnServiceList, boxIndex, _moveToTimePicker} = props;
    let [specialInstructions, setSpecialInstructions] = useState(props.specialInstructions || "")
    const selectServicesFxn = async () => {
        if (!serviceList || (serviceList && !serviceList.length)) {
            return NotificationManager.warning('Please choose services');
        }
        _moveToTimePicker()
    }


    return (
        boxIndex == 1 ? <>
            <div className={'row'}>
                <div className={'col-md-12'}>
                    <div className={'locationPicker'}>
                        <div className="laundryPlaceOrder laundryPlaceOrder-step2 intro-info">
                            <div className={'logoBox'}>
                                <LazyLoadImage src="/assets/img/1StopWash-logo.svg"
                                               className="img-fluid"/>
                            </div>
                            <div id="custom-search-input">
                                <p className="text-row">Select Services</p>
                                <div className={'service-list-container small'}>
                                    {categoryList && categoryList.length ?
                                        <PlaceOrderServiceComponent
                                            categoryList={categoryList}
                                            {...props}
                                            selectedIndex={selectedIndex}
                                            serviceList={serviceList}
                                            returnServiceList={returnServiceList}/>
                                        : null}


                                    <div className="related-form mt-4">
                                        <input placeholder={"Special instructions (Optional)"}
                                               value={specialInstructions}
                                               onChange={({target}) => {
                                                   setSpecialInstructions(target.value)
                                               }}
                                               className={'form-control shadow-0'}/>
                                    </div>

                                </div>
                                <div className="place-order btn_group">
                                    <button className="btn btn-back"
                                            onClick={() => {
                                                props.goBackFxn();
                                            }}>
                                        <img src="/assets/img/arrow-left.png"/>&nbsp;Back
                                    </button>
                                    <button className="btn btn-my" type="button" id={"schedulePickUp"}
                                            onClick={() => selectServicesFxn()}>
                                        Next &nbsp;<img src="/assets/img/arrow-right.png"/>
                                    </button>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </> : null
    )
}
export default Step2
